import { render } from "./GaleryOffice.vue?vue&type=template&id=3627332e"
import script from "./GaleryOffice.vue?vue&type=script&lang=js"
export * from "./GaleryOffice.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/declic-center-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__